export default __webpack_public_path__ + "static/media/logo_mga.11114c4a.png";